
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/competence/[slug]",
      function () {
        return require("private-next-pages/competence/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/competence/[slug]"])
      });
    }
  